import { Pipe, PipeTransform } from '@angular/core';
import { TransactionDetails } from '@modules/wallet/component/transaction-detail-modal/constant';

@Pipe({
  name: 'isDeductionTransaction',
  standalone: true
})
export class IsDeductionTransactionPipe implements PipeTransform {

  private deductionTypes = [
    TransactionDetails.TRANSACTION_TYPE_PURCHASE,
    TransactionDetails.TRANSACTION_TYPE_WITHDRAWAL,
    TransactionDetails.TRANSACTION_TYPE_REFUND_DEDUCTED,
    TransactionDetails.DELEGATOR_PAYMENT,
    TransactionDetails.FAN_REFUND_ISSUED,
    TransactionDetails.DELEGATION_REFUND_ISSUED
  ];

  transform(transactionType: any): boolean {
    return this.deductionTypes.includes(transactionType);
  }
}